import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { CARDS_TYPE } from '../../enums/cardTypes';
import { cardsStore } from '../../store/cardsStore';
import { gameStore } from '../../store/gameStore';
import { MAIN_HAND_TYPE, SPLIT_HAND_TYPE } from '../../enums/constants';

const PlayerCard = observer(({ hand, boxIndex, isSplit }) => {
  const { animationByBox, selectedCardBackSideType, selectedCardType } = cardsStore;
  const {
    activeAnimationBox,
    activeHandByBox,
    activeBox,
    isSplitCardAnimationByBox,
    isInsuranceDecisionOpened,
  } = gameStore;

  const isHandActive = useMemo(() => {
    if (!isSplit) {
      return (activeBox === boxIndex && !activeHandByBox) || activeBox === null;
    }
    return (activeBox === boxIndex && +activeHandByBox === SPLIT_HAND_TYPE) || activeBox === null;
  }, [isSplit, activeBox, boxIndex, activeHandByBox]);

  const isActiveAnimationByHand = useMemo(() => {
    if (isSplit) {
      return isSplitCardAnimationByBox === SPLIT_HAND_TYPE;
    }
    return isSplitCardAnimationByBox === MAIN_HAND_TYPE;
  }, [isSplitCardAnimationByBox, isSplit]);

  return (
    <div
      className={`tb-player-hand 
      ${hand?.isShowBjAnim ? 'black-jack' : ''} 
      ${hand?.isDouble ? 'doubled' : ''}
      ${isHandActive || isInsuranceDecisionOpened ? '' : 'inactive'}`}
    >
      {hand?.cards?.map(({ card, index: key }, index) => {
        return (
          <div
            className={`tb-player-card ${
              hand.cards.length - 1 === index
                ? (activeAnimationBox === boxIndex &&
                    isActiveAnimationByHand &&
                    animationByBox[boxIndex]) ||
                  ''
                : ''
            }`}
            key={key}
          >
            <div className={`tb-card deck-1 cover-1 open ${CARDS_TYPE[card]}`}>
              <span className={`tb-card-front-side ${selectedCardType}`} />
              <span className={`tb-card-back-side ${selectedCardBackSideType}`} />
            </div>
          </div>
        );
      })}
    </div>
  );
});
export default PlayerCard;
